import { Component, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { AspMyItemListService } from '../asp-my-item-list/asp-my-item-list.service';
import { collectExternalReferences } from '@angular/compiler';
import { MyJobCardsDetailsService } from '../my-job-cards-details/my-job-cards-details.service';
import * as words from 'number-to-words';
import { AspCartService } from '../asp-cart/asp-cart.service';
import { AspOrderListService } from '../asp-order-list/asp-order-list.service';
import { AspInstantOrderQuoteService } from './asp-instant-order-quote.service';
import { GlobalVariable } from 'app/main/globals';
import { AspLoginService } from '../asp-login/asp-login.service';
import { MatBottomSheet } from '@angular/material/bottom-sheet';

@Component({
  selector: 'app-asp-instant-order-quote',
  templateUrl: './asp-instant-order-quote.component.html',
  styleUrls: ['./asp-instant-order-quote.component.scss']
})
export class AspInstantOrderQuoteComponent implements OnInit {

  showCarDetails: boolean;
  placeOrder: boolean;
  successPopup: boolean;
  successIcon: string = '../../../../assets/icons/icons8-ok.gif';
  vehicleData: any;
  updatedArray: any;
  allHaveData: any;
  someHaveData: any;
  noneHaveData: any;
  missingArray: any[];
  requestId: any;
  instantOrder: any;
  shippingCharges: any;
  contactName: string;
  contactEmail: string;
  contactPhone: string;
  addresses: any;
  magicQuote: boolean;
  id: number;
  itemList: any;
  respose: Object;
  loading: boolean;
  wrongPartNames: any;
  spareRequest: any;
  avoidShippingCharges: any;
  spareRequestItemList: any;

  constructor(private route: ActivatedRoute,
    private aspInstantOrderQuoteService: AspInstantOrderQuoteService,
    private myJobCardsDetailsService: MyJobCardsDetailsService,
    private router: Router,
    private aspCartService: AspCartService,
    private aspOrderListService: AspOrderListService,
    private aspLoginService: AspLoginService, 
    private bottomSheet: MatBottomSheet,
  ) {}
 @ViewChild('bottomSheetTemplate') bottomSheetTemplate!: TemplateRef<any>;

  ngOnInit(): void {
    this.aspLoginService.checkLogin();
    this.id = Number(this.route.snapshot.paramMap.get('id'));
      const cartCountEl = document.getElementsByClassName('animate-cta')[0] as HTMLElement;

// To hide
// cartCountEl.style.display = 'none';
     this.route.queryParams.subscribe();
      this.vehicleData=JSON.parse(sessionStorage.getItem('vehicleData'));
      // console.log("this.vehicleData",this.vehicleData);
      // this.getItemList();
      this.contactName=localStorage.getItem('contactName');
      this.contactEmail=localStorage.getItem('contactEmail');
      this.contactPhone=localStorage.getItem('contactPhone');
      this.getAdress();
      this.getSpareQuotation();
  }
getSpareQuotation(){
  this.loading=true;
  const spareGarageId=localStorage.getItem('merchantId')
   this.aspInstantOrderQuoteService.getSpareQuotation(this.id, spareGarageId).subscribe(
      res => {
        
  this.loading=false;
        this.respose=res['response'].body.spareQuotation;
        localStorage.setItem('requestId',this.respose['requestId'])
        // console.log("response", res);
        this.spareRequest=res['response'].body.spareRequest
        this.itemList=res['response'].body.spareQuotation.itemList;
        // console.log("itemList",this.itemList);
        this.getShippingCharges(); 
        this.spareRequestItemList= res['response'].body.spareRequestItemList;
        const wrongOnly = res['response'].body.spareRequestItemList.filter(wrong =>
  !this.itemList.some(item => item.partNumber === wrong.partNumber)
);

this.wrongPartNames = wrongOnly.map(item => item.itemName);
if(this.wrongPartNames){
  localStorage.setItem('missingItemNames', JSON.stringify(this.wrongPartNames));
}else{
  localStorage.removeItem("missingItemNames");
}

// console.log(this.wrongPartNames); // ["Coolant Green (1L)"]

  const partNumbers = this.itemList.map(item => item.partNumber);

  this.aspInstantOrderQuoteService.getPartKeyData(partNumbers).subscribe((res: any) => {
    const map = res?.data?.partNumberPartKeyMap;

    if (map) {
      this.itemList = this.itemList.map(item => ({
        ...item,
        partKey: map[item.partNumber] || null
      }));

      // console.log('Updated itemList with partKey:', this.itemList);
    }
  });

      });
  }
carDetails(hide){
  this.showCarDetails=hide;
}
getAdress(){
   this.aspOrderListService.getAdress().subscribe(
      res => {
        // console.log("res",res);
        this.addresses = (res['data'].filter(item => item.addressType === "shipping")[0]);
        // console.log("this.addresses",this.addresses)
      })
}


//   getItemList(){
//   let garageKey = localStorage.getItem('garageKey');
//   const relevancyCount = 3;
//   const names = this.receivedData.map(item => item.suggestion).join(', ');
//    this.aspInstantOrderQuoteService
//       .getSuggest(relevancyCount, this.vehicleData.variantKey, names, garageKey)
//       .subscribe((result) => {
//       console.log("result",result)
//       if (result.code == 200) {
//         this.updatedArray = [];
// this.missingArray = [];

// this.receivedData.forEach(item => {
//   const suggestionKey = item.suggestion;
//   const matchedKey = Object.keys(result.data).find(key => key === suggestionKey);

//   if (matchedKey && result.data[matchedKey]) {
//     this.updatedArray.push({
//       ...item,
//       data: [result.data[matchedKey][0]]  // Only first item
//     });
//   }  else {
//   const detailEntry = result.details[suggestionKey];
//   let id = 0;

//   if (
//     detailEntry &&
//     typeof detailEntry === 'object' &&
//     !Array.isArray(detailEntry)
//   ) {
//     const value = Object.values(detailEntry)[0];
//     if (typeof value === 'number') {
//       id = value;
//     }
//   }

//   this.missingArray.push({
//     ...item,
//     id: id
//   });
// }

// });


// console.log(this.updatedArray);
// console.log(this.missingArray);
// // Extract only itemName values
// const itemNames = this.missingArray.map(i => i.name);

// // Save to localStorage
// if(this.missingArray){
// localStorage.setItem('missingItemNames', JSON.stringify(itemNames));
// }else{
//   localStorage.removeItem('missingItemNames');
// }
// this.allHaveData = this.updatedArray.every(item => item.data && item.data.length > 0);
// this.someHaveData = this.updatedArray.some(item => item.data && item.data.length > 0) &&
//                     this.updatedArray.some(item => !item.data || item.data.length === 0);
// this.noneHaveData  = this.updatedArray.every(item => !item.data || item.data.length === 0);
// console.log("this.allHaveData",this.allHaveData)
// console.log("this.someHaveData",this.someHaveData)
// console.log("this.noneHaveData ",this.noneHaveData )
// const requestId = localStorage.getItem('requestId');
//   if(this.missingArray && !localStorage.getItem('requestId')){
//     let notes = this.receivedData.map(item => item.suggestion).join(', ');
//         let garageKey = localStorage.getItem('garageKey');
//         let jobcardId= '';
//         let spareRequestId= '';
//         const items = this.missingArray.map(value => ({
//     partType: 'oem',
//     itemQuantity: value.quantity ?? 1,
//     searchKey: value.suggestion,
//     itemName: value.name,
//     itemDescription: value.name,
//     lineItemId: value.id?.toString() ?? '0',
//     status: '1'
//   }));
//     this.myJobCardsDetailsService.createB2BRequest(this.vehicleData.rowKey, this.vehicleData.make, this.vehicleData.model, this.vehicleData.fuel, this.vehicleData.vin || '', this.vehicleData.variantKey, this.vehicleData.variant, this.vehicleData.year, this.vehicleData.registrationNumber || '', notes, jobcardId, items, spareRequestId).subscribe(
//               (res: any) => {
//                 console.log("res",res)
//                 if(res?.response?.statusCode==200 && res?.response?.body?.sparerequest?.id){
//                   this.requestId = res?.response?.body?.sparerequest?.id;
//                   localStorage.setItem("requestId",res?.response?.body?.sparerequest?.id);
//                 }
//               },
//               (err) => {
//                 console.error('B2B request API failed', err);
//               }
//             );
//   }

//     this.getShippingCharges();      
// }
//     })
// }

getTotalAmount(): number { 
  const total = this.itemList?.reduce((sum, item) => {
    return sum + (item.mrp * item.itemQuantity);
  }, 0);
  return total;
}
convertNumberToWords(amount: number): string {
  const words = require('number-to-words'); // You may need to install this
  return words.toWords(amount).replace(/\b\w/g, l => l.toUpperCase()) + ' Rupees Only';
}
placeOrderNow(){
this.instantOrder = {};
// this.totalAmount = 0;

let make = this.respose['make'];
let model = this.respose['model'];
let registrationNumber = this.respose['regNo'] || '';
let variant = this.respose['variant'];
let mfgYear = this.respose['manufacturingYear'];
let fuelType = this.respose['fuelType'];
let rowKey =this.respose['rowKey'];
let variantKey = this.spareRequest['variantKey'];

this.itemList.forEach(item => { 
  let stock = item;
  const itemKey = item.partKey;

  let newItem: any = {
    ...stock.spareStocks,
    ...stock,
    cart_qty: item.itemQuantity,
    key: itemKey,
    partKey: itemKey,
    name: item.itemName,
    partName: item.itemName,
    discount: (item.mrp * item.sellingDiscount) / 100,
    mrp:item.mrp,
    selectedMake: make,
    selectedModel: model,
    registrationNumber: registrationNumber,
    variant: variant,
    selectedYear: mfgYear,
    selectedFuel: fuelType,
    rowKey: rowKey,
    variantKey: variantKey
  };

  // Set item with partKey as key
  this.instantOrder[itemKey] = newItem;
});


sessionStorage.setItem('instantOrder', JSON.stringify([this.instantOrder]));
// console.log("Added Cart:", this.instantOrder);
// console.log("Total Amount:", this.totalAmount);

this.router.navigate(['slot']); 
localStorage.setItem("instantOrderPay",'true');
}
 // Shipping charges
  getShippingCharges(){     
    let garageKey = localStorage.getItem('garageKey');
    this.aspCartService.getShippingCharges(this.getTotalAmount(), garageKey).subscribe(
      result => {
        // console.log("resultship",result)
        let res = JSON.parse(JSON.stringify(result)); 
        if(res.code==200){
          this.shippingCharges = res.data.shippingCharges;
          this.avoidShippingCharges=res.data.avoidShippingCharges;
          // }
        } else {
          console.log("Unexpected response code:", res.code);  // Log if the response code is not 200
        }
      }
    );
  }

async downloadPDF() {
  
  this.loading=true;
  this.magicQuote = true;

  // 🕒 Wait for Angular to render DOM from *ngIf
  await new Promise((resolve) => setTimeout(resolve, 200)); // Give time for rendering

  const html2pdfModule = await import('html2pdf.js');
  const html2pdf = html2pdfModule.default || html2pdfModule;

  const element = document.getElementById('magicQuote');

  if (!element) {
    console.error('Element not found!');
    this.magicQuote = false;
    return;
  }


  const options = {
    margin: [5, 5, 5, 5],
    filename: 'magicQuote.pdf',
    image: { type: 'jpeg', quality: 1.0 },
    html2canvas: {
      scale: 2,
      useCORS: true,
      logging: false,
      scrollX: 0,
      scrollY: 0,
      windowWidth: document.documentElement.scrollWidth,
      windowHeight: document.documentElement.scrollHeight,
    },
    jsPDF: { unit: 'mm', format: 'a4', orientation: 'portrait' }
  };

  await html2pdf().from(element).set(options).save();

  this.magicQuote = false; // Optionally hide it again
  this.loading=false;
}
getTotalDiscount(): number {
  if (!this.itemList || !Array.isArray(this.itemList)) {
    return 0;
  }

  let totalDiscount = 0;

  for (const item of this.itemList) {
    const price = Number(item.mrp) || 0;
    const quantity = Number(item.itemQuantity) || 0;
    const discountPercent = Number(item.sellingDiscount) || 0;

    const discountPerUnit = (price * discountPercent) / 100;
    const discountForItem = discountPerUnit * quantity;

    totalDiscount += discountForItem;
  }

  return totalDiscount;
}


getTotalDiscountPercent(): number {
  if (!this.itemList || this.itemList.length === 0) return 0;

  let totalDiscount = 0;

  this.itemList.forEach(item => {
    const discount = Number(item.sellingDiscount) || 0;

    totalDiscount += discount;
  });

  return Number(totalDiscount.toFixed(2));
}




shareQuoteOnWhatsApp() {

  let message = '';
    const spareSelectedGarageName=localStorage.getItem("spareSelectedGarageName");
    // console.log("wrong",this.wrongPartNames)
  if (this.wrongPartNames?.length <=0) {
    message = `✨ *Hi ${spareSelectedGarageName}*,

Your Autoverse Magic Quote is ready! 🛠️✨

Some items are quoted, and others are requested *(Request ID: ${this.respose['requestId']})*.

Check the details on your My Request page.

🔮 *Total Price:* ₹${(this.getTotalAmount()- this.getTotalDiscount()+ this.shippingCharges).toFixed(2)}
💸 *Discount:* ${this.getTotalDiscountPercent().toFixed(2)}%
🎁 *You Saved:* ₹${this.getTotalDiscount().toFixed(2)}
🚚 *Shipping:* ₹${this.shippingCharges}

Ready to order? Click below:
🔗 ${GlobalVariable.AUTOVERSE_WEB}/magic-quote/${this.id}

Visit My Request for more on the requested items.

*– Team Autoverse*`;
  } else {
    message = `✨ *Hi ${spareSelectedGarageName}*,

Hope you're having a fantastic day! ✨

Your *Autoverse Magic Quote* is here, and it’s just the right fit for your needs! 🛠️✨

🔮 *Total Price:* ₹${(this.getTotalAmount()-this.getTotalDiscount()+ this.shippingCharges).toFixed(2)}
💸 *Discount:* ${this.getTotalDiscountPercent().toFixed(2)}%
🎁 *You Saved:* ₹${this.getTotalDiscount().toFixed(2)}
🚚 *Shipping:* ₹${this.shippingCharges}

Ready to place your order? Click below:
🔗 ${GlobalVariable.AUTOVERSE_WEB}/magic-quote/${this.id}

We’re always here to make your experience smoother. Reach out anytime! 💬

*– Team Autoverse*`;
  }

  const whatsappURL = `https://api.whatsapp.com/send?text=${encodeURIComponent(message)}`;
  window.open(whatsappURL, '_blank');
}

  openBottomSheet(): void {
    this.bottomSheet.open(this.bottomSheetTemplate,{
     panelClass: 'custom-bottom-sheet1'
    }
    );
  } 
  hasSalesOrder(): boolean {
  return this.spareRequestItemList.some(item =>
    item.salesOrderId && item.salesOrderId.trim() !== ''
  );
}
 goToOrder(){
  // window.location.href = '/order-list';
  this.router.navigate(['order-list']); 
 }
  closeBottomSheet(): void {
    if (this.bottomSheet) {
      this.bottomSheet.dismiss();
    }
  }
}
